<template>
    <div style='touch-action: manipulation' class="mb-5">
        <div>
          <v-toolbar class="main">
            <button class="nav-back" @click="backToHome"><v-icon>keyboard_arrow_left</v-icon> Välj kund</button>
          </v-toolbar>
        </div>
        <center>
            <h1>{{ this.$store.state.currentDistributor.name }}</h1>
        </center>
        <v-container grid-list-md text-xs-center inventory>
          <v-layout row wrap mb-3>
              <v-flex xs6>
                  <v-card>
                      <div class="image-container">
                          <img class="rounded" alt="Helpall" src="../assets/pallet.jpg">
                          <div class="description">Helpall</div>
                      </div>

                    <div class="counter">
                      <v-layout row wrap>
                        <v-flex xs4>
                          <v-btn  @click="$store.commit('distDecrementPalletAmountIn')"> - </v-btn>
                        </v-flex>
                        <v-flex xs4>
                          <input class="palletDisplay" v-model="pallet_quantity_in" readonly>
                        </v-flex>
                        <v-flex xs4>
                          <v-btn  @click="$store.commit('distIncrementPalletAmountIn')"> + </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-card>
              </v-flex>
              <v-flex xs6>
                  <v-card>
                      <div class="image-container">
                          <img class="rounded" alt="Halvpall" src="../assets/pallet-half.jpg">
                          <div class="description">Halvpall</div>
                      </div>

                    <div class="counter">
                      <v-layout row wrap>
                        <v-flex xs4>
                          <v-btn  @click="$store.commit('distDecrementPalletHalfAmountIn')"> - </v-btn>
                        </v-flex>
                        <v-flex xs4>
                          <input class="palletDisplay" v-model="pallet_half_quantity_in" readonly>
                        </v-flex>
                        <v-flex xs4>
                          <v-btn  @click="$store.commit('distIncrementPalletHalfAmountIn')"> + </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-card>
              </v-flex>
              <v-flex xs6>
                  <v-card>
                      <div class="image-container">
                          <img class="rounded" alt="Rullcontainer" src="../assets/rolling_pallet.jpg">
                          <div class="description">Rullcontainer</div>
                      </div>

                    <div class="counter">
                      <v-layout row wrap>
                        <v-flex xs4>
                          <v-btn  @click="$store.commit('distDecrementRollingPalletAmountIn')"> - </v-btn>
                        </v-flex>
                        <v-flex xs4>
                          <input class="palletDisplay" v-model="rolling_pallet_quantity_in" readonly>
                        </v-flex>
                        <v-flex xs4>
                          <v-btn  @click="$store.commit('distIncrementRollingPalletAmountIn')"> + </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-card>
              </v-flex>
              <v-flex xs6>
                  <v-card>
                      <div class="image-container">
                          <img class="rounded" alt="Engångspall" src="../assets/Engangspall.jpg">
                          <div class="description">Engångspall</div>
                      </div>

                      <div class="counter">
                          <v-layout row wrap>
                              <v-flex xs4>
                                  <v-btn  @click="$store.commit('distDecrementDisposablePalletAmountIn')"> - </v-btn>
                              </v-flex>
                              <v-flex xs4>
                                  <input class="palletDisplay" v-model="disposable_pallet_quantity_in" readonly>
                              </v-flex>
                              <v-flex xs4>
                                  <v-btn  @click="$store.commit('distIncrementDisposablePalletAmountIn')"> + </v-btn>
                              </v-flex>
                          </v-layout>
                      </div>
                  </v-card>
              </v-flex>
              <v-flex xs6>
                  <v-card>
                      <div class="image-container">
                          <img class="rounded" alt="Plastpall" src="../assets/plastpall.jpg">
                          <div class="description">Halvpall</div>
                      </div>

                    <div class="counter">
                      <v-layout row wrap>
                        <v-flex xs4>
                          <v-btn  @click="$store.commit('distDecrementPlastpallAmountIn')"> - </v-btn>
                        </v-flex>
                        <v-flex xs4>
                          <input class="palletDisplay" v-model="plastpall_quantity_in" readonly>
                        </v-flex>
                        <v-flex xs4>
                          <v-btn  @click="$store.commit('distIncrementPlastpallAmountIn')"> + </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-card>
              </v-flex>
              <v-flex xs6>
                  <v-card>
                      <div class="image-container">
                          <img class="rounded" alt="Plastpall Halv" src="../assets/Plastpall-half.jpg">
                          <div class="description">Plastpall Halv</div>
                      </div>

                      <div class="counter">
                          <v-layout row wrap>
                              <v-flex xs4>
                                  <v-btn  @click="$store.commit('distDecrementPlastpallHalfAmountIn')"> - </v-btn>
                              </v-flex>
                              <v-flex xs4>
                                  <input class="palletDisplay" v-model="plastpall_half_quantity_in" readonly>
                              </v-flex>
                              <v-flex xs4>
                                  <v-btn  @click="$store.commit('distIncrementPlastpallHalfAmountIn')"> + </v-btn>
                              </v-flex>
                          </v-layout>
                      </div>
                  </v-card>
              </v-flex>
              <v-flex xs6>
                  <v-card>
                      <div class="image-container">
                          <img class="rounded" alt="Lökbin" src="../assets/lok-bin.jpg">
                          <div class="description">Lökbin</div>
                      </div>

                      <div class="counter">
                          <v-layout row wrap>
                              <v-flex xs4>
                                  <v-btn  @click="$store.commit('distDecrementLokbinAmountIn')"> - </v-btn>
                              </v-flex>
                              <v-flex xs4>
                                  <input class="palletDisplay" v-model="lokbin_quantity_in" readonly>
                              </v-flex>
                              <v-flex xs4>
                                  <v-btn  @click="$store.commit('distIncrementLokbinAmountIn')"> + </v-btn>
                              </v-flex>
                          </v-layout>
                      </div>
                  </v-card>
              </v-flex>
              <v-flex xs6>
                  <v-card>
                      <div class="image-container">
                          <img class="rounded" alt="Kyl" src="../assets/kyl.jpg">
                          <div class="description">Kyl</div>
                      </div>

                      <div class="counter">
                          <v-layout row wrap>
                              <v-flex xs4>
                                  <v-btn  @click="$store.commit('distDecrementKylAmountIn')"> - </v-btn>
                              </v-flex>
                              <v-flex xs4>
                                  <input class="palletDisplay" v-model="kyl_quantity_in" readonly>
                              </v-flex>
                              <v-flex xs4>
                                  <v-btn  @click="$store.commit('distIncrementKylAmountIn')"> + </v-btn>
                              </v-flex>
                          </v-layout>
                      </div>
                  </v-card>
              </v-flex>
              <v-flex xs6>
                  <v-card>
                      <div class="image-container">
                          <img class="rounded" alt="Jätten Bur" src="../assets/giant-cage.jpg">
                          <div class="description">Jätten Bur</div>
                      </div>

                      <div class="counter">
                          <v-layout row wrap>
                              <v-flex xs4>
                                  <v-btn  @click="$store.commit('distDecrementGiantCageAmountIn')"> - </v-btn>
                              </v-flex>
                              <v-flex xs4>
                                  <input class="palletDisplay" v-model="giant_cage_quantity_in" readonly>
                              </v-flex>
                              <v-flex xs4>
                                  <v-btn  @click="$store.commit('distIncrementGiantCageAmountIn')"> + </v-btn>
                              </v-flex>
                          </v-layout>
                      </div>
                  </v-card>
              </v-flex>
          </v-layout>
                        <!-- Signature Stuff -->
            <div>
                <v-text-field class="mb-2" placeholder="Sök på namn" icon="search" v-model="filter"></v-text-field>
                <br>
            </div>
            <div v-for="(signatory, i) in getSignatories" :key="i" >
                <v-btn color="primary" block @click="setSignatoryByBtn(signatory)">{{ signatory }}</v-btn>
                <br>
            </div>
            <div v-if="this.filter != ''">
                <v-btn color="primary" block @click="setSignatoryByTextInput(filter)">Lägg till &quot;{{ this.filter }}&quot;</v-btn>
            </div>
                        <!-- Signature Stuff End -->
        </v-container>
    </div>
</template>

<script>
import required from 'vuelidate/lib/validators'

export default {
    data(){
        return{
            select:null,
            valid: true,
            validations: {
                select: { required }
            },
            showSigInput: false,
            sigInput: null,
            distSignatories: [],
            filter: ''
        }
    },
    methods: {
        setSignatoryByBtn(name){
            this.$store.state.distributorTransaction.signed = name;
            this.$router.push('Signature');
        },
        setSignatoryByTextInput(name){
            if (name !== null) {
                this.$store.state.distributorTransaction.signed = name;
                this.$router.push('Signature');
            } else {
                window.alert("Välj en u eller ange en ny.");
            }
        },
        backToHome(){
          this.$router.push('Warehouse_Home');
        }
    },
    computed: {
        getSignatories(){
            var _this = this;
            //this.customers = this.$store.state.currentCustomers.slice(0, 50);
            var distSignatories = this.$store.state.currentSignatories.filter(function (player) {
                return player.toLowerCase().indexOf(_this.filter.toLowerCase()) !== -1;
            });

            return distSignatories;
        },
        rolling_pallet_quantity_in: {
          get(){
            return this.$store.state.currentDistributorPallets.pallets.rolling_pallet.quantity_in;
          },
          set (){}
        },
        pallet_quantity_in: {
          get(){
            return this.$store.state.currentDistributorPallets.pallets.pallet.quantity_in;
          },
          set (){}
        },
        pallet_half_quantity_in: {
          get(){
            return this.$store.state.currentDistributorPallets.pallets.pallet_half.quantity_in;
          },
          set (){}
        },
        plastpall_quantity_in: {
          get(){
            return this.$store.state.currentDistributorPallets.pallets.plastpall.quantity_in;
          },
          set (){}
        },
        plastpall_half_quantity_in: {
          get(){
            return this.$store.state.currentDistributorPallets.pallets.plastpall_half.quantity_in;
          },
          set (){}
        },
        lokbin_quantity_in: {
          get(){
            return this.$store.state.currentDistributorPallets.pallets.lokbin.quantity_in;
          },
          set (){}
        },
        kyl_quantity_in: {
          get(){
            return this.$store.state.currentDistributorPallets.pallets.kyl.quantity_in;
          },
          set (){}
        },
        giant_cage_quantity_in: {
          get(){
            return this.$store.state.currentDistributorPallets.pallets.giant_cage.quantity_in;
          },
          set (){}
        },
        disposable_pallet_quantity_in: {
          get(){
            return this.$store.state.currentDistributorPallets.pallets.disposable_pallet.quantity_in;
          },
          set (){}
        }
    }
}
</script>

<style>

.palletDisplay{
  width: 33%;
  text-align: center;
}

.image-container{
    position: relative;
    top: 0px;
}

.card .description {
    position: absolute;
    letter-spacing: 0;
    margin-top: 10px;
    margin-left: 10px;
    font-size: 13px;
    padding: 0 10px;
    color: #7b7b7b;
    background: #f3f3f3;
    border-radius: 99px;
    top: 0;
    left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Distributor_Delivery.vue